import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import IButton from "../button/i-button.component";
import TitlePanel from "../title-panel/title-panel.component";
import { ReactNode, useEffect, useState } from "react";
import { EMPTY_STRING, VIEW_MODE } from "../../features/common/constants";
import { isNotEmpty } from "../../features/common/util.services";
import { Box } from "@mui/system";

export type IFormProps = {
    title?: string;
    submitForm?: any;
    resetForm?: any;
    cancelForm?: any;
    export?: any;
    mainComponent?: ReactNode;
    saveButtonText?: string;
    resetButtonText?: string;
    cancelButtonText?: string;
    showCancelBtn?: boolean;
    showResetBtn?: boolean;
    showSaveBtn?: boolean;
    showExportBtn?: any;
    formData?: any;
    mode?: string;
    cancelNavigation?: boolean; // true - navigate to the previous page
}

const IForm = (props: IFormProps) => {
    const methods = useForm({ defaultValues: props.formData });
    const navigate = useNavigate();
    const showSaveBtn = props.showSaveBtn === false ? props.showSaveBtn : true;
    const showCancelBtn = props.showCancelBtn === false ? props.showCancelBtn : true;
    const showExportBtn = props.showExportBtn === true ? props.showExportBtn : false;
    const title = props.title ? props.title : EMPTY_STRING;
    const saveButtonText = props.saveButtonText ? props.saveButtonText : 'Submit';
    const resetButtonText = props.resetButtonText ? props.resetButtonText : 'Reset';
    const cancelButtonText = props.cancelButtonText ? props.cancelButtonText : 'Cancel';
    const cancelNavigation = isNotEmpty(props.cancelNavigation) ? props.cancelNavigation : true;
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (props.mode === VIEW_MODE) {

        }
    }, [props.mode]);

    useEffect(() => {
        methods.reset(props.formData);
    }, [props.formData]);

    const onSubmit = async (data: any) => {
        setIsSubmitting(true);
        if (props.submitForm) {
            props.submitForm(data);
        }

        try { 
            await new Promise((resolve) => setTimeout(resolve, 3000));
        } finally {
            setIsSubmitting(false);
        }
    }
    const onReset = () => {
        if (props.resetForm) {
            props.resetForm();
        }
    }
    const onExport = () => {
        if (props.export) {
            props.export();
        }
    }
    const onCancel = () => {
        if(cancelNavigation) {
            navigate(-1);
        }

        if (props.cancelForm) {
            props.cancelForm();
        }
    }
    const renderForm = () => {
        return <FormProvider {...methods}>
            <form>
                {props.mainComponent}
                <Box display="flex" justifyContent="center" width="100%" mt={2}>
                    {props.showResetBtn && <IButton label={resetButtonText} type="reset" 
                    onActionEvent={() => { methods.reset(); onReset() }} color="secondary"></IButton>}
                    {showSaveBtn && <IButton label={saveButtonText} type="button" color="primary" 
                    onActionEvent={methods.handleSubmit(onSubmit)} disabled={isSubmitting}></IButton>}
                    {showCancelBtn && <IButton label={cancelButtonText} type="button" 
                    onActionEvent={() => { methods.reset(); onCancel() }} color="secondary"></IButton>}
                    {showExportBtn && <IButton label={'Export'} type="button" 
                    onActionEvent={() => { methods.reset(); onExport() }} color="secondary"></IButton>}
                </Box>
            </form>
        </FormProvider>
    }

    return title ? <TitlePanel panelBody={renderForm()} title={title} /> : renderForm();
}

export default IForm;